import { FC } from "react";
import styles from './LeftBarWrapper.module.scss';
import weblogo from '../../assets/svg/weblogo.svg';
import { useTranslation } from 'react-i18next';
import { ReactComponent as FreeAccountIcon } from '../../assets/svg/freeAccountIcon.svg';
import { ReactComponent as VisibilityIcon } from '../../assets/svg/visibilityIcon.svg';
import { ReactComponent as ManageInquiriesIcon } from '../../assets/svg/manageInquiriesIcon.svg';
import { ReactComponent as ControlProfileIcon } from '../../assets/svg/controlProfileIcon.svg';
import { ReactComponent as PublishedProcurementsIcon } from '../../assets/svg/publishedProcurementsIcon.svg';

type Props = {
  children: React.ReactNode,
}

export const LeftBarWrapper: FC<Props> = ({ children }) => {
  const [t] = useTranslation('newSupplier', { keyPrefix: 'signUp' });

  return (
    <div className={styles.pageContainer}>
    <div className={styles.leftColumn}>
      <div className={styles.logoSection}>
        <img src={weblogo} />
      </div>
      
      <div className={styles.featuresSection}>
        <div className={styles.feature}>
          <div className={styles.featureIcon}>
            <FreeAccountIcon />
          </div>
          <div className={styles.featureContent}>
            <div className={styles.featureTag}>{t('feature1.tag', 'Kostnadsfritt')}</div>
            <div className={styles.featureTitle}>{t('feature1.title', 'Gratis leverantörskonto')}</div>
            <p className={styles.featureDescription}>
              {t('feature1.description', 'Få synlighet, trovärdighet och tillgång till förfrågningar - helt gratis.')}
            </p>
          </div>
        </div>

        <div className={styles.feature}>
          <div className={styles.featureIcon}>
            <VisibilityIcon />
          </div>
          <div className={styles.featureContent}>
            <div className={styles.featureTitle}>{t('feature2.title', 'Mer synlighet hos riktiga köpare')}</div>
            <p className={styles.featureDescription}>
              {t('feature2.description', 'Visa er i databaser för förfrågningar och få fler anbudsförfrågningar.')}
            </p>
          </div>
        </div>

        <div className={styles.feature}>
          <div className={styles.featureIcon}>
            <ManageInquiriesIcon />
          </div>
          <div className={styles.featureContent}>
            <div className={styles.featureTitle}>{t('feature3.title', 'Hantera era förfrågningar på ett ställe')}</div>
            <p className={styles.featureDescription}>
              {t('feature3.description', 'Följ och hantera alla förfrågningar och anbud på ett ställe.')}
            </p>
          </div>
        </div>

        <div className={styles.feature}>
          <div className={styles.featureIcon}>
            <ControlProfileIcon />
          </div>
          <div className={styles.featureContent}>
            <div className={styles.featureTitle}>{t('feature4.title', 'Styr hur inköpare ser ert företag')}</div>
            <p className={styles.featureDescription}>
              {t('feature4.description', 'En komplett profil med logotyp och kontaktuppgifter ökar er synlighet och trovärdighet.')}
            </p>
          </div>
        </div>

        <div className={styles.feature}>
          <div className={styles.featureIcon}>
            <PublishedProcurementsIcon />
          </div>
          <div className={styles.featureContent}>
            <div className={styles.featureTitle}>{t('feature5.title', 'Publicerade upphandlingar')}</div>
            <p className={styles.featureDescription}>
              {t('feature5.description', 'Inköpare kan publicera sina förfrågningar i Accurator för att nå fler leverantörer. Med ett leverantörskonto får ni tillgång till dessa upphandlingar och nya kunder.')}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div className={styles.rightColumn}>
      {children}
    </div>
  </div>
  )
}